export const FILTER_SAVED = 'location/filter_saved';
